// components/Sender/channels.js
import { WORKER_TYPE } from "./workers";

export const CHANNELS = {
  email:           { icon: "📧", label: "Email",           color: "#1d4ed8", bg: "#dbeafe" },
  contact:         { icon: "📝", label: "Contact form",    color: "#0891b2", bg: "#cffafe" },
  calendly:        { icon: "📅", label: "Calendly",        color: "#a855f7", bg: "#f3e8ff" },
  emailAndContact: { icon: "✉️", label: "Email + Contact", color: "#16a34a", bg: "#dcfce7" },
};

export const CHANNEL_ORDER = ["email", "contact", "calendly", "emailAndContact"];

export function normalizeChannel(raw) {
  const s = String(raw || "").trim().toLowerCase();
  if (!s) return null;
  if (s === "email" || s === "email_only") return "email";
  if (s === "contact" || s === "contact_form" || s === "cf") return "contact";
  if (s === "calendly") return "calendly";
  if (s === "emailandcontact" || s === "contactandemail" ||
      s === "both" || s === "email_and_contact" ||
      s === "contact_and_email") return "emailAndContact";
  return null;
}

// Из массива platforms кампании → Set каналов, к которым она пригодна
export function campaignPlatformSet(campaign) {
  const set = new Set();
  const platforms = campaign?.platforms || [];
  platforms.forEach((p) => {
    const ch = normalizeChannel(p);
    if (ch) set.add(ch);
  });
  // если platforms не заданы — пробуем message_templates
  if (set.size === 0) {
    const mt = campaign?.message_templates || {};
    if (mt.EMAIL) set.add("email");
    if (Array.isArray(mt.CONTACT_FORM) || mt.CONTACT_FORM) set.add("contact");
    if (mt.CALENDLY) set.add("calendly");
  }
  return set;
}

// Возвращает первую строку совместимую с campaign_type если platforms пусты
export function campaignChannel(campaign) {
  const set = campaignPlatformSet(campaign);
  if (set.size === 0) return null;
  if (set.size > 1) return "emailAndContact";
  return Array.from(set)[0];
}

// Безопасное имя кампании (для табличек)
export function campaignName(campaigns, id) {
  const c = campaigns?.[String(id)];
  if (!c) return `#${id}`;
  if (typeof c === "string") return c;
  return c.name || `#${id}`;
}

// Тип воркера (channel-совместимый)
export function workerChannel(w) {
  if (!w) return "email";
  const t = String(w._type || w.worker_type || "").trim();
  const norm = normalizeChannel(t);
  if (norm) return norm;
  return "email";
}

// Воркеры, подходящие под канал кампании (используем worker_type)
export function workersForChannels(workers, campaignChannels) {
  if (!campaignChannels || campaignChannels.size === 0) return [...(workers || [])];

  const wantEmail = campaignChannels.has("email") || campaignChannels.has("emailAndContact");
  const wantContact = campaignChannels.has("contact") || campaignChannels.has("emailAndContact");
  const wantCalendly = campaignChannels.has("calendly");

  return (workers || []).filter((w) => {
    const t = String(w._type || w.worker_type || "").trim().toLowerCase();
    if (t === "email") return wantEmail;
    if (t === "contact") return wantContact;
    if (t === "calendly") return wantCalendly;
    if (t === "contactandemail") return wantEmail || wantContact;
    // неизвестный тип — показываем, пусть юзер сам решит
    return true;
  });
}

export function ChannelBadge({ channel, size = "md" }) {
  const cfg = CHANNELS[channel] || CHANNELS.email;
  const pad = size === "sm" ? "2px 6px" : "4px 10px";
  const fz = size === "sm" ? 10 : 11;
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 4,
      padding: pad, borderRadius: 6, fontSize: fz, fontWeight: 700,
      background: cfg.bg, color: cfg.color, whiteSpace: "nowrap",
    }}>
      {cfg.icon} {cfg.label}
    </span>
  );
}